<label class="switch">
    <input type="checkbox" [(ngModel)]="switch" (ngModelChange)="toggle();">
    <span class="slider round" [ngStyle]="{'background-color': currentColor}"></span>
</label>